import { Component, OnInit, ChangeDetectionStrategy, ViewEncapsulation, ChangeDetectorRef } from '@angular/core';
import { noop, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { PanelsInterfaceComponent, PanelsInterfaceComponentBase } from '../panels-interface.component';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import toLower from 'lodash-es/toLower';
import startCase from 'lodash-es/startCase';
import { ProjectsService } from 'app/modules/projects/projects.service';
import { AccountService } from 'app/core';
import { Disposition } from 'app/modules/projects/@shared/types/dispositions.types';
import { AddDispositionsComponent } from 'app/modules/projects/@shared/components/add-dispositions/add-dispositions.component';
import { DispositionsService } from 'app/modules/projects/@shared/services/dispositions.service';
import { AddDispositionsGroupComponent } from 'app/modules/projects/@shared/components/add-dispositions-group/add-dispositions-group.component';
import { Store } from '@ngxs/store';
import { NewPermission } from '@core/enums';

@Component({
  selector: 'project-panel-dispositions',
  templateUrl: './dispositions.component.html',
  styleUrls: ['./dispositions.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PanelsDispositionsComponent
  extends PanelsInterfaceComponentBase
  implements PanelsInterfaceComponent, OnInit
{
  private _unsubscribeAll: Subject<void>;

  dispositions: Disposition[]; //remove
  displayColumns: string[];
  dispositionsDataSources: MatTableDataSource<any>[] = [];
  clickButton: boolean = false;
  dispositionGroups: any[];
  addedToGroup = null;
  NewPermission = NewPermission;

  constructor(
    private _matDialog: MatDialog,
    protected readonly _changeDetectorRef: ChangeDetectorRef,
    private _dispositionService: DispositionsService,
    private _projectsService: ProjectsService,
    private _accountService: AccountService,
  ) {
    super(_changeDetectorRef);
    this._unsubscribeAll = new Subject();
    this.displayColumns = ['transaction_type', 'workflow_state', 'offer_price', 'due_diligence_period', 'closing_date'];
    this._accountService.currentAccount.subscribe((accountData) => {
      this._dispositionService.accountId = accountData.id;
      this._projectsService.project$.subscribe((project) => {
        this._dispositionService.projectId = project.id;
      });
    });
  }

  ngOnInit() {
    this.titleFieldDef = {
      name: 'dispositions.panel_name',
      label: this.panelDef.title,
      type: 'text',
    };

    this._dispositionService.getDispositionGroups().subscribe(noop);

    this._dispositionService.dispositionGroups$.pipe(takeUntil(this._unsubscribeAll)).subscribe((response: any) => {
      if (response) {
        this.dispositionGroups = response.disposition_groups;
      }
      this._changeDetectorRef.markForCheck();
    });
  }

  openAddDispositionModal(group): void {
    const dialogRef = this._matDialog.open(AddDispositionsComponent, {
      panelClass: 'mailbox-compose-dialog',
      data: { project: this.project, options: this.data.options, group: group },
    });

    dialogRef.afterClosed().subscribe((result) => {
      let index = this.dispositionGroups.findIndex((group) => group.id === group.id);
      this.dispositionGroups[index].disposition_group_transactions.push(
        result.disposition.disposition_group_transaction,
      );
      this._changeDetectorRef.markForCheck();
    });
  }

  openAddDispositionGroupModal(token = '', groupName = ''): void {
    let disposition = { token: '', group_name: '' };
    disposition.token = token;
    disposition.group_name = groupName;
    const dialogRef = this._matDialog.open(AddDispositionsGroupComponent, {
      panelClass: 'mailbox-compose-dialog',
      data: { project: this.project, options: this.data.options, disposition: disposition },
    });

    dialogRef.afterClosed().subscribe(noop);
  }

  openEditDispositionModel(disposition, group): void {
    const dialogRef = this._matDialog.open(AddDispositionsComponent, {
      panelClass: 'mailbox-compose-dialog',
      data: { project: this.project, options: this.data.options, disposition: disposition, group: group },
    });

    dialogRef.afterClosed().subscribe(noop);
  }

  openEditDispositionGroupModel(group): void {
    const dialogRef = this._matDialog.open(AddDispositionsGroupComponent, {
      panelClass: 'mailbox-compose-dialog',
      data: { project: this.project, options: this.data.options, group: group },
    });

    dialogRef.afterClosed().subscribe(() => {
      this.clickButton = false;
    });
  }

  deleteGroup(group) {
    this._dispositionService.deleteDispositionGroup(group.id).subscribe();
  }

  trackByFn(index: number, item: any): any {
    return item.id || index;
  }

  upperCase(word) {
    return startCase(toLower(word));
  }
}
